var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9998 14.9999C17.7738 14.9999 17.5468 14.9239 17.3597 14.7679L11.9887 10.2919L6.62675 14.6069C6.19775 14.9539 5.56775 14.8859 5.22075 14.4549C4.87475 14.0249 4.94275 13.3959 5.37375 13.0489L11.3737 8.22092C11.7437 7.92192 12.2747 7.92592 12.6407 8.23192L18.6407 13.2319C19.0647 13.5849 19.1217 14.2159 18.7688 14.6399C18.5708 14.8769 18.2867 14.9999 17.9998 14.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWide);
export default __webpack_public_path__ + "static/media/ArrowUpWide.b6810ba2fcb62f146263e73fe8b7f686.svg";
export { ForwardRef as ReactComponent };